import { inject, Provider } from '@angular/core';
import {
  INFC_DEDICATED_POOL_SOURCE,
  InfCDedicatedPoolSource,
  InfCLoginResponseDto,
} from '@infodata-group/inf-commons-core';
import { AuthorizationService } from './authorization.service';

/**
 * Provides the source of `infcDedicatedPoolInterceptor` (`@infodata-group/inf-commons-core`):
 * the pool returned by the login (`userContext`) and the API end point of the `AuthorizationService`.
 *
 * With `initApi`, the `userContext` is the response of `initApi`, not the one of the login:
 * the pool is only found if `initApi` returns it too.
 *
 * @example
 * provideHttpClient(withInterceptors([infcDedicatedPoolInterceptor])),
 * provideDedicatedPool(),
 */
export function provideDedicatedPool(): Provider {
  return {
    provide: INFC_DEDICATED_POOL_SOURCE,
    useFactory: (): InfCDedicatedPoolSource => {
      const auth = inject(AuthorizationService);
      return {
        pool: () => (auth.userContext as Partial<InfCLoginResponseDto> | null)?.pool,
        apiEndPoint: () => auth.apiEndPoint,
      };
    },
  };
}
